import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MethodsUtils } from "../../util/methods.utils";
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {ModalLogRotinaComponent} from '../../modais/modal-log-rotina/modal-log-rotina.component';

@Component({
  selector: 'app-titulo',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './titulo-component.html',
  styleUrls: ['./titulo-component.css'],
})
export class TituloRotinaComponent {
  @Input() titulo?: string;
  @Input() idRotina?: number;
  @Input() backRotina = false;
  @Input() rotinaRetorno?: string;
  @Input() confirmarRetorno = false;
  @Input() foraAppComponent = false;
  @Output() cancelarEmit = new EventEmitter();

  private readonly location = inject(Location);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  voltar(){
    if (!this.confirmarRetorno || window.confirm('Pode possuir alterações não salvas, deseja fechar?')) {
      this.retornar(true);
    }
  }

  retornar(podeRetornar: boolean) {
    if (podeRetornar) {
      if (!this.backRotina) {
        if (this.rotinaRetorno) {
          this.router.navigate([this.rotinaRetorno]);
        } else {
          this.location.back()
        }
      } else {
        this.cancelarEmit.emit()
      }
    }
  }

  get isMobile() {
    return MethodsUtils.detectar_mobile();
  }

  abrirModalLog() {
    this.dialog.open(ModalLogRotinaComponent, {
      width: '361px',
      height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: {
        rotinaId: this.idRotina
      },
      panelClass: 'slide-modal'
    });
  }
}
